/**
 * Calculate live statistics from runs data
 */
export const calculateLiveStats = (runs) => {
  if (!runs || runs.length === 0) {
    return {
      success_rate: 0,
      avg_latency_ms: 0,
      total_tokens: 0,
      total_cost: 0
    };
  }

  const successfulRuns = runs.filter(r => r.status === 'success');
  const totalLatency = runs.reduce((sum, r) => sum + (r.latency_ms || 0), 0);
  const totalTokens = runs.reduce((sum, r) => sum + (r.token_usage?.total_tokens || 0), 0);
  const totalCost = runs.reduce((sum, r) => sum + (r.estimated_cost || 0), 0);

  return {
    success_rate: runs.length > 0 ? (successfulRuns.length / runs.length) * 100 : 0,
    avg_latency_ms: runs.length > 0 ? totalLatency / runs.length : 0,
    total_tokens: totalTokens,
    total_cost: totalCost
  };
};

/**
 * Calculate performance percentiles from runs data
 */
export const calculatePerformanceMetrics = (runs) => {
  if (!runs || runs.length === 0) {
    return { p50: 0, p95: 0, p99: 0, min: 0, max: 0, avg: 0 };
  }

  const latencies = runs
    .map(r => r.latency_ms || 0)
    .filter(l => l > 0)
    .sort((a, b) => a - b);

  if (latencies.length === 0) {
    return { p50: 0, p95: 0, p99: 0, min: 0, max: 0, avg: 0 };
  }

  const percentile = (arr, p) => {
    const index = Math.ceil((p / 100) * arr.length) - 1;
    return arr[Math.max(0, index)];
  };

  return {
    p50: percentile(latencies, 50),
    p95: percentile(latencies, 95),
    p99: percentile(latencies, 99),
    min: latencies[0],
    max: latencies[latencies.length - 1],
    avg: latencies.reduce((a, b) => a + b, 0) / latencies.length
  };
};

/**
 * Calculate error summary from runs data
 */
export const calculateErrorSummary = (runs) => {
  if (!runs || runs.length === 0) {
    return {
      total_errors: 0,
      by_type: {}
    };
  }

  const errorRuns = runs.filter(r => r.status !== 'success');
  const byType = {};

  errorRuns.forEach(run => {
    const errorType = run.error_type || 'unknown_error';
    if (!byType[errorType]) {
      byType[errorType] = {
        count: 0,
        latest_error: null,
        latest_timestamp: null
      };
    }
    byType[errorType].count++;
    if (!byType[errorType].latest_timestamp || 
        new Date(run.created_at) > new Date(byType[errorType].latest_timestamp)) {
      byType[errorType].latest_error = run.error_message;
      byType[errorType].latest_timestamp = run.created_at;
    }
  });

  return {
    total_errors: errorRuns.length,
    by_type: byType
  };
};

